// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles.scss
// module id = 6
// module chunks = 0